import React, {FC} from 'react';
import classNames from 'classnames';

type Props = {
  text?: string;
  selected?: boolean;
  border?: boolean;
  icon?: React.ReactNode;
  selectedColor?: string;
  bgColor?: string;
};
export const TextLabel: FC<Props> = ({
  text,
  selected,
  border = true,
  icon = null,
  selectedColor = '!bg-[#ffcb58]/[.15]',
  bgColor = 'bg-gray-100',
}: Props) => {
  return (
    <div
      className={classNames(
        'flex gap-1 px-3 items-start py-2 m-1 space-x-1 text-sm rounded-full w-fit',
        {
          [selectedColor]: selected,
          [bgColor]: border,
        },
      )}
    >
      {icon}
      {text}
    </div>
  );
};
